import iconPoint from '../../assets/images/attendance-v2/icon-point.png';
import iconRandomBox from '../../assets/images/attendance-v2/icon-random-box.png';
import iconSpecial from '../../assets/images/attendance-v2/icon-special.png';
import heroStamp from '../../assets/images/attendance-v2/hero-stamp.png';
import checkStamp from '../../assets/images/attendance-v2/check-stamp.png';
import attendanceLine from '../../assets/images/attendance-v2/attendance-line.png';

function rewardIcon(rewardType) {
  if (rewardType === 'RANDOM_BOX') return iconRandomBox;
  if (rewardType === 'SPECIAL') return iconSpecial;
  return iconPoint;
}

function DayCard({ day }) {
  const done = day.status === 'DONE';
  const today = day.status === 'TODAY';
  const special = Boolean(day.special);

  let cardClass =
    'relative flex h-[95px] w-12 shrink-0 flex-col items-center overflow-hidden rounded-[10px] border border-solid';
  if (done) {
    cardClass += ' border-gray02 bg-gradient-to-b from-white to-[#d9d9d9]';
  } else if (today) {
    cardClass += ' border-2 border-primary-purple-01 bg-[#c4b5ed]';
  } else if (special) {
    cardClass += ' border-yellow-01 bg-gradient-to-b from-background01 to-[#fff3d9]';
  } else {
    cardClass += ' border-[rgba(139,104,221,0.3)] bg-gradient-to-b from-white to-[#dfd7ff]';
  }

  // if (today) {
  //   cardClass += ' ring-2 ring-primary-purple-01';
  // }

  const dayColor = done ? 'text-gray03' : 'text-primary-purple-01';

  return (
    <div className={cardClass}>
      <span className={`mt-1.5 text-center font-['Pretendard'] text-sm font-bold tracking-[-0.3px] ${dayColor}`}>
        {day.dayNo}
      </span>
      <img src={rewardIcon(day.rewardType)} alt="" className="mt-0.5 h-9 w-8 object-contain" />
      <span className="mt-auto mb-1.5 whitespace-pre-line px-0.5 text-center font-['Pretendard'] text-[9px] font-bold leading-tight tracking-[-0.3px] text-gray04">
        {day.rewardLabel}
      </span>
      {done && (
        <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
          <img src={checkStamp} alt="출석" className="h-10 w-10 object-contain" />
        </div>
      )}
    </div>
  );
}

function ctaLabel(ctaType) {
  if (ctaType === 'CATCHUP') return '놓친 출석 바로 이어하기';
  if (ctaType === 'DONE') return '오늘 출석 완료';
  return '오늘 출석하기';
}

function RewardLegend() {
  return (
    <div className="mx-auto flex w-[340px] items-center justify-center gap-[38px] rounded-[30px] bg-white/80 py-2.5 pl-5 pr-7">
      <div className="flex items-center gap-[5px]">
        <img src={iconPoint} alt="" className="h-6 w-6 object-contain" />
        <span className="font-['Pretendard'] text-xs font-bold tracking-[-0.3px] text-gray04">일반보상</span>
      </div>
      <div className="flex items-center gap-[5px]">
        <img src={iconRandomBox} alt="" className="h-6 w-[22px] object-contain" />
        <span className="font-['Pretendard'] text-xs font-bold tracking-[-0.3px] text-gray04">랜덤박스</span>
      </div>
      <div className="flex items-center gap-[5px]">
        <img src={iconSpecial} alt="" className="h-6 w-5 object-contain" />
        <span className="font-['Pretendard'] text-xs font-bold tracking-[-0.3px] text-gray04">특별보상</span>
      </div>
    </div>
  );
}

function DayGrid({ days }) {
  const firstRow = days.slice(0, 7);
  const secondRow = days.slice(7, 14);

  return (
    <div className="flex flex-col items-center gap-0.5">
      <div className="flex gap-0.5">
        {firstRow.map((day) => (
          <DayCard key={day.dayNo} day={day} />
        ))}
      </div>
      <div className="flex gap-0.5">
        {secondRow.map((day) => (
          <DayCard key={day.dayNo} day={day} />
        ))}
      </div>
    </div>
  );
}

export default function AttendanceChallengeBoard({ data, onCta, busy = false, compact = false }) {
  const days = Array.isArray(data?.days) ? data.days : [];
  const disabled = data?.ctaType === 'DONE' || busy;

  const hero = (
    <div className={`relative ${compact ? 'px-6 pt-2' : 'px-6 pt-4'}`}>
      <h1 className="font-['Pretendard'] text-[30px] font-bold leading-[1.5] tracking-[-0.3px] text-black">
        출석체크 챌린지
      </h1>
      <p className="mt-1 max-w-[180px] font-['Pretendard'] text-base font-bold leading-[1.5] tracking-[-0.3px] text-primary-purple-01">
        간단 출석체크하고
        <br />
        바로 보상 받아가세요
      </p>
      <img
        src={heroStamp}
        alt=""
        className="pointer-events-none absolute right-4 top-4 h-[101px] w-[100px] object-contain"
      />
    </div>
  );

  const cta = (
    <button
      type="button"
      disabled={disabled}
      onClick={onCta}
      className={`mx-auto flex h-[54px] w-[340px] items-center justify-center rounded-2xl border-0 bg-gradient-to-b from-primary-blue to-primary-purple-01 font-['Pretendard'] text-lg font-bold tracking-[-0.3px] text-white outline-none ${
        disabled ? 'opacity-50' : ''
      }`}
    >
      {ctaLabel(data?.ctaType)}
    </button>
  );

  if (compact) {
    return (
      <div className="flex w-full flex-col bg-background01">
        {hero}
        <div className="mt-6">
          <RewardLegend />
        </div>
        <div className="mt-4">
          <DayGrid days={days} />
        </div>
        <div className="mt-5">{cta}</div>
      </div>
    );
  }

  return (
    <div className="flex w-full flex-col">
      <div className="bg-background01">
        {hero}
        <div className="mt-6">
          <RewardLegend />
        </div>
        <img src={attendanceLine} alt="" className="pointer-events-none mt-2 block w-full select-none" />
      </div>
      <div className="bg-white pt-1">
        <DayGrid days={days} />
        <div className="mt-5 pb-2">{cta}</div>
      </div>
    </div>
  );
}
